// components/common/ExportCsv.js
import Papa from "papaparse";
import { saveAs } from "file-saver";

export const exportVisibleColumnsToCSV = (table, data, filename = "export.csv") => {
  const visibleColumns = table.getVisibleLeafColumns();

  const headers = visibleColumns.map((col) => col.columnDef.header);
  const csvData = data.map((row, index) =>
    visibleColumns.map((col) => {
      if (col.id === "S.NO") return index + 1;
      const accessorFn = col.columnDef.accessorFn;
      return accessorFn ? accessorFn(row, index) : row[col.id] ?? "";
    })
  );

  const csv = Papa.unparse({ fields: headers, data: csvData });
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  saveAs(blob, filename);
};
